import { Switch as MuiSwitch, SwitchProps as MuiSwitchProps } from '@mui/material';

export interface SwitchProps extends MuiSwitchProps {}

// The Tradehaus switch. Its shape and materials live in the theme (MuiSwitch in theme/components.ts, the --tx-switch-*
// tokens), so a raw MUI Switch anywhere in the app is the same control; size="small" is the row size
export const Switch = (props: SwitchProps) => <MuiSwitch {...props} />;
